import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import GameConfig from "./games/GameConfig";
import { InputCell, Table, EditDeleteCell, NewRowTemplate, CheckboxCell, RedirectButtonCell } from "../../components/BasicComponents";
import { useNavigate } from "react-router-dom";

function GamesTable({ games, genders, onModify, onDelete, onAdd }) {    

    return (
        <>
        <Table headers={["Nom du jeu", "Capacité", "Autre", ""]}>
            {games.map((data) => (
                <GamesRow
                    key={data.id}
                    id={data.id}
                    name={data.name}
                    capacity={data.capacity}
                    genders={genders}
                    onModify={onModify}
                    onDelete={onDelete}
                />
            ))}
            <NewRow onAdd={onAdd} />
        </Table>
        </>
    );
}

function GamesRow({ id, name, capacity, genders, onModify, onDelete }) {
    let app = useApp();

    let navigate = useNavigate();

    let [change, setChange] = useState(false);
    let [name0, setName0] = useState(name);
    let [capacity0, setCapacity0] = useState(capacity);

    function submitChange(e) {        
        if(app.emptyCheck(name0)) {
            return alert("Le nom est vide");
        }

        if(app.emptyCheck(capacity0) || capacity0 < 1) {
            return alert("La capacité est invalide");
        }

        onModify(id, name0, capacity0);
        setChange(false);
    }

    function del(e) {
        if(window.confirm("Vous êtes sur le point de supprimer le jeu: " + name + ". Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    }

    function onClickDetail() {
        navigate();
    }

    return (
        <>
            <tr>
                <InputCell value={name0} onChange={e => { setName0(e.target.value); setChange(true) }} placeholder="Nom du jeu" />
                <InputCell type="number" min={1} value={capacity0} onChange={e => { setCapacity0(e.target.value); setChange(true) }} placeholder="Capacité du jeu" />
                <RedirectButtonCell 
                    redirectTo={id + "/"}
                    text={"Détail"}
                />
                <EditDeleteCell onEdit={submitChange} onDelete={del} change={change} />
            </tr>
        </>
    );
}

function NewRow({ onAdd }) {
    let [newName, setNewName] = useState("");
    let [newCapacity, setNewCapacity] = useState(1);

    function add() {
        onAdd(newName, newCapacity, data => {
            setNewName("");
            setNewCapacity(1);
        });
    }

    return (
        <NewRowTemplate>
            <InputCell value={newName} onChange={(e) => { setNewName(e.target.value) }} placeholder="Nom du jeu" />
            <InputCell type="number" min={1} value={newCapacity} onChange={e => { setNewCapacity(e.target.value) }} placeholder="Capacité du jeu" />
            <td></td>
            <td>
                <button onClick={add}>Ajouter</button>
            </td>
        </NewRowTemplate>
    );
}

function Games() {
    let app = useApp();

    let [games, setGames] = useState([]);
    let [genders, setGenders] = useState([]);
    let [update, setUpdate] = useState(0);


    useEffect(() => {
        app.sendGet("/game/list", data => {
            const games = [];
            for(let game of data) {
                let gameIndex = -1;
                if((gameIndex = games.findIndex(val => val.id === game.id)) !== -1)
                    games[gameIndex].constraints.push(game.gender_id);
                else 
                    games.push({id: game.id, name: game.name, capacity: game.capacity, constraints: game.gender_id!==null?[game.gender_id+""]:[]});
            }

            setGames(games);
        });

        app.sendGet("/student/genders", data => {
            setGenders(data);
        });
    }, [update]);

    function onAdd(name, capacity, callback = (data) => {}) {
        if(app.emptyCheck(name)) {
            return alert("Le nom du jeu est vide.");
        }

        if(app.emptyCheck(capacity) || capacity < 1) {
            return alert("La capacité du jeu est invalide.");
        }

        if(games.some(game => game.name === name)) {
            return alert("Un jeu avec ce nom existe déjà.");
        }

        app.sendPost("/game/add", {name: name, capacity: capacity}, data => {
            if(data.success === false) {
                alert("Error: " + data.message);
                return;
            }

            setGames([... games, {id: data.id, name: data.name, capacity: data.capacity, constraints: []}]);
            callback(data);
        });
    }

    function onModify(id, name, capacity) {
        if(games.some(game => game.name === name && game.id != id)) {
            return alert("Un jeu avec ce nom existe déjà.");
        }

        app.sendPost("/game/update", {id: id, name: name, capacity: capacity}, data => {            
            setGames(games.map(g => g.id===id?({...g, name: name, capacity: capacity}):g))
            setUpdate(update + 1);
        });
    }

    function onDelete(id) {
        app.sendPost("/game/delete", {id: id}, data => {
            setUpdate(update + 1);
        });
    }


    return (
        <>
            <h1>Les jeux</h1>
            <GamesTable games={games} genders={genders} onModify={onModify} onDelete={onDelete} onAdd={onAdd} />
            <hr />
            <div>
                <h2>Configuration</h2>
                <div>
                <GameConfig />
                </div>
            </div>
        </>
    );
}

export default Games;